<template>
    <div class="columns">
        <div class="column is-fullwidth">
            <b class="is-inline region-header" @click="selectAllAuctionsByRegion(region)">
                {{ region }}
            </b>
            <hr>
            <div class="columns is-multiline is-flex">
                <auction-stock v-for="(auction, index) in getAuctionsByRegion(region)" :auction="auction" :key="index" :region="region"></auction-stock>
            </div>
        </div>
    </div>
</template>

<script>
    import AuctionStock from './AuctionStock.vue'
    export default {
        props: ['region', 'counter'],
        components: {
            AuctionStock
        },
        methods: {
            getAuctionsByRegion(region) {
                return this.$store.getters.getAllAuctionsByRegionStock(region)
            },
            selectAllAuctionsByRegion(region) {
                this.$store.dispatch('addAllAuctionsByRegionForAllDaysStock', region)
            }
        }
    }
</script>

<style scoped>
    .region-header {
        cursor: pointer;
    }
    hr {
        margin: 10px!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/AuctionsStock.vue